import React, {FC, useState, useRef, useEffect} from "react"
import {Button} from "../../inputs/Button"
import {Input} from "../../inputs/Input"
import {clipboardService} from "../../service/clipboardService"
import './EditCellDialog.less'

interface CellPosition {
    rowIndex: number
    cellIndex: number
}

interface Props {
    isOpen: boolean
    initialValue: string
    version: number
    position: CellPosition | null
    onClose: () => void
    onSave: (newValue: string, position: CellPosition) => void
}

export const EditCellDialog: FC<Props> = ({
                                              isOpen,
                                              initialValue,
                                              version,
                                              position,
                                              onClose,
                                              onSave
                                          }) => {
    const dialogRef = useRef<HTMLDivElement>(null)
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue, version])

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onClose()
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSave()
        } else if (e.key === 'Escape') {
            onClose()
        }
    }

    const handleSave = () => {
        if (position) {
            onSave(value, position)
        }
    }

    const handleCopy = () => {
        clipboardService.copyTo(value, false)
    }

    if (!isOpen || !position) {
        return null
    }

    return (
        <div className="csv-cell-edit-overlay" onClick={handleOverlayClick}>
            <div
                className="csv-cell-edit-dialog"
                ref={dialogRef}
                onKeyDown={handleKeyDown}
                tabIndex={0}
            >
                <div className="csv-cell-edit-header">
                    Edit Cell
                </div>
                <div className="csv-cell-edit-body">
                    <Input
                        id="cell-value"
                        label="Value"
                        value={value}
                        placeholder="Enter cell value"
                        autoFocus={true}
                        autoSelect={true}
                        withoutHeader={true}
                        setValue={setValue}
                        onConfirm={handleSave}
                        onCancel={onClose}
                    />
                </div>
                <div className="csv-cell-edit-footer">
                    <Button
                        title="Copy"
                        onClick={handleCopy}
                        className="csv-cell-edit-copy-btn"
                    />
                    <div className="csv-cell-edit-footer-right">
                        <Button
                            title="Cancel"
                            onClick={onClose}
                            className="csv-cell-edit-cancel-btn"
                        />
                        <Button
                            title="Save"
                            onClick={handleSave}
                            className="csv-cell-edit-save-btn"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
